const NINumberOutput = props => {
    const value = props.value ?? props.question?.value ?? '';
    return value.replace(/^(.{2})(.{2})(.{2})(.{2})(.{1})$/, '$1 $2 $3 $4 $5').toUpperCase();
};

export default NINumberOutput;
